import { useState } from "react";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import { Button } from "@/client/components/base/button";
import { InputGroup, InputGroupAddon, InputGroupInput } from "@/client/components/base/input-group";

export default function PasswordInput({
    id,
    value,
    placeholder,
    invalid,
    autoComplete,
    onChange,
}: {
    id: string;
    value: string;
    placeholder?: string;
    invalid?: boolean;
    autoComplete: string;
    onChange: (value: string) => void;
}) {
    const [visible, setVisible] = useState(false);

    return (
        <InputGroup data-invalid={invalid ? "" : undefined}>
            <InputGroupInput
                id={id}
                type={visible ? "text" : "password"}
                value={value}
                placeholder={placeholder}
                autoComplete={autoComplete}
                aria-invalid={invalid}
                onChange={(event) => onChange(event.target.value)}
            />
            <InputGroupAddon>
                <Button
                    type="button"
                    variant="ghost"
                    size="icon-sm"
                    aria-label={visible ? "Hide password" : "Show password"}
                    onClick={() => setVisible((current) => !current)}
                >
                    {visible ? <EyeOffIcon /> : <EyeIcon />}
                </Button>
            </InputGroupAddon>
        </InputGroup>
    );
}
